import type { FaireProductEntity } from "../../entity_types/product";

export const p_9avzj7z2j2: FaireProductEntity = {
  token: "p_9avzj7z2j2",
  type: "product",
  name: "Teacup Babies Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/30f5fe6a67e95cd984780172d545ed7603555b12aa0cc8fcbe1226a9d48be15c.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fc20ddf2563c5319af29c2cd832bb12182b631e29bf8583107e330a17f39fce0.png",
    "https://cdn.faire.com/fastly/cfe8da7f6c99ec8fe920566042dd04ee2c766c481973b1d425da5a4a4b2e744b.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:22.899Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
